<template>
  <div class="text-center">
    <a :class="getStyle" v-on:click="goBack">Back</a>
  </div>
</template>

<script>

export default {
  props: {
    classNames: {
      type: String
    },
  },
  computed: {
    getStyle() {
      return this?.classNames || 'btn bg-neutral hover:bg-gray-600 text-xl';
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
}
</script>
